import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryDepartTreeList, queryUserTreeList } from '@/api/api';
import pick from 'lodash.pick';
import moment from 'moment/moment';
import comment from '@comp/comment/comment.vue';
import workFlowSelect from '@comp/workFlow/workFlowSelect.vue';
import workFlow from '@comp/workFlow/workFlowYc.vue';
import { httpAction } from '@api/manage';
import IwsUpload from '@comp/upload/IwsUpload.vue';
export default {
  name: 'ProcessCurrencyModal',
  components: {
    IwsUpload: IwsUpload,
    comment: comment,
    workFlow: workFlow,
    workFlowSelect: workFlowSelect
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '通用审批表单表单',
      startUser: null,
      addState: true,
      userInfo: this.$store.getters.userInfo,
      tabsKey: '1',
      tableName: 'om_process_currency',
      // deptTree: [],
      userTree: [],
      form_fields: ['userId', 'sendNumber', 'title', 'documentType', 'level', 'degree', 'content', 'status', 'remark'],
      // form_fields_time: ['startTime', 'endTime'],
      form_fields_time: [],
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入标题!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择申请人!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loadTree();
  },
  methods: {
    loadTree: function loadTree() {
      var _this = this;

      var that = this; // that.deptTree = []

      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      }); // 部门
      // queryDepartTreeList().then((res) => {
      //   if (res.success) {
      //     for (let i = 0; i < res.result.length; i++) {
      //       let temp = res.result[i]
      //       that.deptTree.push(temp)
      //     }
      //     this.loading = false
      //   }
      // })
    },
    add: function add() {
      this.tabsKey = '1';
      this.addState = true;
      this.edit({
        userId: this.userInfo.id
      });
    },
    edit: function edit(record) {
      var _this2 = this;

      console.log('record', record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {
        this.startUser = {
          key: this.model.createBy,
          label: this.model.createBy_userName
        };
        this.addState = false;
      }

      this.$nextTick(function () {
        var that = _this2; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          var workFlowItemList = _this3.$refs.workFlowSelect.getWorkFlowItemList();

          if (workFlowItemList.some(function (v) {
            return v.approvalUser.length == 0;
          })) {
            _this3.$message.error('请选择审批人！');

            return;
          }

          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData);
          formData.workFlow = {
            flowSrc: 'om_process_currency',
            userId: _this3.userInfo.id,
            workFlowItemList: workFlowItemList
          };
          console.log('formDataformData', formData);
          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this3.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    updateFile: function updateFile() {
      var that = this;
      var httpurl = this.url.edit ? this.url.edit : this.pagePath;
      var method = 'put';
      var formData = {
        id: that.model.id
      };
      formData = that.$refs.iwupload.getUploadListToFromData(formData);
      httpAction(httpurl, formData, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: '上传成功'
          });
        } else {
          that.$notification.warning({
            message: '上传失败'
          });
        }
      });
    },
    fileChange: function fileChange() {
      if (!this.addState) {
        this.updateFile();
      }
    }
  }
};